export const SPEND_COUNT_COLUMN_WIDTH_PX = 96;
export const SPEND_AMOUNT_COLUMN_WIDTH_PX = 148;
export const SPEND_PERCENT_COLUMN_WIDTH_PX = 96;

export function fixedColumnWidth(width: number): {
    minWidth: number;
    maxWidth: number;
} {
    return { minWidth: width, maxWidth: width };
}
